import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  activeSection: string;
  onChange: any;
}

const ProfileMenu = ({ activeSection, onChange, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[ProfileMenu] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[ProfileMenu] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div
        className={`section ${activeSection === "contacts" ? "active" : ""}`}
        onClick={() => onChange("contacts")}
      >
        {t("pages.profile.my_contacts.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "events" ? "active" : ""}`}
        onClick={() => onChange("events")}
      >
        {t("pages.profile.my_events.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "appointments" ? "active" : ""}`}
        onClick={() => onChange("appointments")}
      >
        {t("pages.profile.my_appointments.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "businessCards" ? "active" : ""}`}
        onClick={() => onChange("businessCards")}
      >
        {t("pages.profile.my_business_cards.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "personal" ? "active" : ""}`}
        onClick={() => onChange("personal")}
      >
        {t("pages.profile.my_personal_information.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "business" ? "active" : ""}`}
        onClick={() => onChange("business")}
      >
        {t("pages.profile.my_business_information.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "cfu" ? "active" : ""}`}
        onClick={() => onChange("cfu")}
      >
        {t("pages.profile.forms.cfu_data.title")}
        <i className="fas fa-angle-right"></i>
      </div>
      <div
        className={`section ${activeSection === "chat" ? "active" : ""}`}
        onClick={() => onChange("chat")}
      >
        {t("pages.profile.chat.title")}
        <i className="fas fa-angle-right"></i>
      </div>
    </>
  );
};
export default ProfileMenu;
